export const DUPLICATE_PT5_MESSAGE =
  "This PT-5 number has already been entered for another property. Please enter new PT-5 number.";

export const isDuplicatePt5Error = (err) => Boolean(err?.response?.data?.duplicatePin);

export const getPropertyUpdateErrorMessage = (err, fallback = "Failed to save reassessment") => {
  if (isDuplicatePt5Error(err)) {
    return DUPLICATE_PT5_MESSAGE;
  }
  return err?.response?.data?.error || fallback;
};
